import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from './components/layout/MainLayout';
import Login from './components/identity/login/Login';
import MFA from './components/identity/mfa/Mfa';
import EmailVerifyOTP from "./components/identity/mfa/EmailVerifyOtp";
import MFAQ from "./components/identity/mfa/Mfaq";
import Question from "./components/identity/mfa/Question";
import QrCode from "./components/identity/mfa/QrCode";
import Forgot from "./components/identity/forgot/Forgot";
import Reset from "./components/identity/reset/Reset";
import Logout from "./components/identity/logout/Logout";
import ProtectedRoute from "./auth/ProtectedRoute";
import ResetPassword from "./components/identity/reset/ResetPassword";
import Alert from "./components/alert/Alert";
import CoursesDashboard from "./components/pages/courses/CourseDashboard";
import Ticket from "./components/pages/ticket/Ticket";
import Support from "./components/pages/support/Support";
import CourseDetails from "./components/pages/courses/CourseDetails";
import CourseUsers from "./components/pages/courses/CourseUsers";
import AddTicket from "./components/pages/support/AddTicket";
import ReportDashboard from "./components/pages/reports/ReportDashboard";
import QuizReport from "./components/pages/reports/QuizReport";
import AssessmentReport from "./components/pages/reports/AssessmentReport";
import AssessmentPracticalReport from "./components/pages/reports/AssessmentPracticalReport";
import IncidentReport from "./components/pages/reports/IncidentReport";
import IncidentMisReport from "./components/pages/reports/IncidentMisReport";
import CourseIncidents from "./components/pages/courses/CourseIncidents";
import Faq from "./components/pages/faq/Faq";
import FaqList from "./components/pages/masters/faq/FaqList";
import FaqMaster from "./components/pages/masters/faq/FaqMaster";
import CyberRange from "./components/pages/cyber-range/CyberRange";
import MasterAssessments from "./components/pages/assessments/masters/MasterAssessments";
import Assessment from "./components/pages/assessments/masters/Assessment";
import Assessments from "./components/pages/assessments/exam/Assessments";
import MasterQuizzes from "./components/pages/quiz/masters/MasterQuizzes";
import Quiz from "./components/pages/quiz/masters/Quiz";
import Quizzes from "./components/pages/quiz/exam/Quizzes";
import Catalogues from "./components/pages/catalogues/Catalogues";
import Dashboard from "./components/pages/dashboard/Dashboard";
import CreateCatalogue from "./components/pages/catalogues/CreateCatalogue";
import LoginHistoryReport from "./components/pages/reports/LoginHistoryReport";
import VmLoginReport from "./components/pages/reports/VmLoginReport";
import DocDetails from "./components/pages/documents/DocDetails";
import RecentLoginHistoryReport from "./components/pages/reports/RecentLoginHistoryReport";
import CatalogueMapping from "./components/pages/catalogues/CatalogueMapping";
import DocumentMapping from "./components/pages/documents/DocumentMapping";
import CategoryDetail from "./components/pages/catalogues/CategoryDetail";
import { FilterProvider } from "./components/layout/FilterContext";
import DocumentType from "./components/pages/documents/Documents";
import DocumentTypes from "./components/pages/masters/documents/DocumentTypes";
import Catagories from "./components/pages/masters/catalogue/Catagories";
import Agents from "./components/pages/support/Agents";
import { ConfirmPopup } from 'primereact/confirmpopup';
import QuizMCQ from "./components/pages/quiz/masters/QuizMCQ";
import MCQAttendees from "./components/pages/quiz/masters/MCQAttendees";
import QuizMCQSessions from "./components/pages/quiz/masters/QuizMCQSessions";
import QuizExam from "./components/pages/quiz/exam/Exam";
import ReviewQuizExam from "./components/pages/quiz/exam/ReviewQuizExam";
import ViewQuizExam from "./components/pages/quiz/masters/ViewQuizExam";
import UploadQuizMCQ from "./components/pages/quiz/masters/UploadQuizMCQ";
import AssessmentMCQ from "./components/pages/assessments/masters/AssessmentMCQ";
import UploadMCQ from "./components/pages/assessments/masters/UploadMCQ";
import AssessmentPractical from "./components/pages/assessments/masters/AssessmentPractical";
import AssessmentTypes from "./components/pages/assessments/masters/AssessmentTypes";
import UserAssessmentTypes from "./components/pages/assessments/exam/UserAssessmentTypes";
import MCQSessions from "./components/pages/assessments/masters/MCQSessions";
import PracticalSessions from "./components/pages/assessments/masters/PracticalSessions";
import AssessmentMCQAttendees from "./components/pages/assessments/masters/AssessmentMCQAttendees";
import AssessmentPracticalAttendees from "./components/pages/assessments/masters/AssessmentPracticalAttendees";
import ViewAssessmentMCQExam from "./components/pages/assessments/masters/ViewAssessmentMCQExam";
import ViewPracticalExam from "./components/pages/assessments/masters/ViewPracticalExam";
import ConfirmAssessment from "./components/pages/assessments/exam/ConfirmAssessment";
import MCQExam from "./components/pages/assessments/exam/MCQExam";
import PracticalExam from "./components/pages/assessments/exam/PracticalExam";
import ReviewMCQExam from "./components/pages/assessments/exam/ReviewMCQExam";
import ReviewPracticalExam from "./components/pages/assessments/exam/ReviewPracticalExam";
import UserGVMs from "./components/pages/courses/userGVMs/UserGVMs";
import UserVMs from "./components/pages/courses/userVMs/UserVMs";
import UserLVMs from "./components/pages/courses/userLVMs/UserLVMs";
import CourseDocuments from "./components/pages/courses/CourseDocuments";
import FaqDetail from "./components/pages/faq/FaqDetail";
import Profile from "./components/pages/profile/Profile";
import EditProfile from "./components/pages/profile/EditProfile";
import UpdateSecurity from "./components/pages/profile/UpdateSecurity";
import MfaReconfigure from "./components/pages/profile/MfaReconfigure";
import ChangePassword from "./components/pages/profile/ChangePassword";
import VerifyOtp from "./components/pages/profile/VerifyOtp";
import UploadFAQ from "./components/pages/masters/faq/UploadFAQ";
import TermsAndConditions from "./components/identity/login/TermsAndConditions";
import DocumentDashboard from "./components/pages/documents/DocumentDashboard";
import CatalogueDashboard from "./components/pages/catalogues/CatalogueDashboard";
import AssessmentDashboard from "./components/pages/assessments/AssessmentDashboard";
import QuizDashboard from "./components/pages/quiz/QuizDashboard";
import CourseViewDoc from "./components/pages/courses/CourseViewDocument";
import TicketDashboard from "./components/pages/ticket/TicketsDashboard";
import Error401 from "./components/pages/error/Error401";
import Error404 from "./components/pages/error/Error404";
import Error408 from "./components/pages/error/Error408";
import Error429 from "./components/pages/error/Error429";
import Error500 from "./components/pages/error/Error500";
import Error502 from "./components/pages/error/Error502";
import Error503 from "./components/pages/error/Error503";
import Error504 from "./components/pages/error/Error504";
import Error403 from "./components/pages/error/Error403";
import Error400 from "./components/pages/error/Error400";
import ErrorOffline from "./components/pages/error/ErrorOffline";
import AssessmentMapping from "./components/pages/assessments/masters/AssessmentMapping";
import QuizMapping from "./components/pages/quiz/masters/QuizMapping";
import { LabActivityProvider } from "./components/pages/cyber-range/LabActivityContext";
import BaySessionsReport from "./components/pages/reports/BaySessionsReport";
import ReleaseIncidentsMapping from "./components/pages/courses/ReleaseIncidentsMapping";
import CreateExpertSession from "./components/pages/masters/expertSessions/CreateExpertSessions";
import UpdateLabHoursCounts from "./components/pages/masters/labHours/UpdateLabHoursCounts";
import AuditLogsTable from "./components/pages/auditlogs/AuditLogsTable";
import ExpertSessions from "./components/pages/masters/expertSessions/ExpertSessions";
import SessionConfirmation from "./components/pages/masters/expertSessions/SessionConfirmation";
import FirstLoginHistoryReport from "./components/pages/reports/FirstLoginHistoryReport";



const App = () => {
  return (
    <>
      <Alert />
      <ConfirmPopup />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/resetpassword/:code" element={<ResetPassword />} />

        {/* Protected Routes inside MainLayout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <FilterProvider>
                <LabActivityProvider>
                <MainLayout />
                </LabActivityProvider>
              </FilterProvider>
            </ProtectedRoute>
          }
        >
          {/* Protected Routes inside MainLayout */}
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="courses" element={<CoursesDashboard />} />
          <Route path="courses/:courseName" element={<CourseDetails />} />
          <Route path="courses/:courseName/catalogues" element={<CourseIncidents />} />
          <Route path="courses/:courseName/catalogue" element={<CategoryDetail />} />
          <Route path="courses/:courseName/users" element={<CourseUsers />} />
          <Route path="courses/:courseName/release-incidents" element={<ReleaseIncidentsMapping/>} />
          <Route path="courses/:courseName/documents" element={<CourseDocuments />} />
          <Route path="courses/:courseName/view-documents" element={<CourseViewDoc />} />
          <Route path="courses/:courseName/vms" element={<UserVMs />} />
          <Route path="courses/:courseName/lvms" element={<UserLVMs />} />
          <Route path="courses/:courseName/gvms" element={<UserGVMs />} />
          <Route path="courses/:courseName/bay-sessions" element={<BaySessionsReport />} />
          <Route path='masters-document-folders' element={<DocumentTypes />} />
          <Route path='masters-catalogues' element={<Catagories />} />
          <Route path="document-dashboard" element={<DocumentDashboard />} />
          <Route path="document" element={<DocumentType />} />
          <Route path="document-dashboard/:docTypeId" element={<DocDetails />} />
          <Route path="document/:docTypeId" element={<DocDetails />} />
          <Route path="document-dashboard/documents" element={<DocDetails />} />
          <Route path="document-dashboard/documents-mapping" element={<DocumentMapping />} />
          <Route path="catalogue-dashboard" element={<CatalogueDashboard />} />
          <Route path="catalogue-dashboard/catalogue" element={<Catalogues />} />
          <Route path="catalogue-dashboard/catalogue/:categoryId" element={<CategoryDetail />} />
          <Route path="catalogue-dashboard/catalogue/all" element={<CategoryDetail />} />
          <Route path="catalogue-dashboard/catalogue/add" element={<CreateCatalogue />} />
          <Route path="catalogue-dashboard/catalogue/edit/:incidentName" element={<CreateCatalogue />} />
          <Route path="catalogue-dashboard/catalogue-mapping" element={<CatalogueMapping />} />
          <Route path="assessment-dashboard" element={<AssessmentDashboard />} />
          <Route path="masters-assessments" element={<MasterAssessments />} />
          <Route path="masters-assessments/add" element={<Assessment />} />
          <Route path="masters-assessments/:assessmentName/edit" element={<Assessment />} />
          <Route path="masters-assessments/:assessmentName" element={<AssessmentTypes />} />
          <Route path="masters-assessments/:assessmentId/assessment-mapping" element={<AssessmentMapping />} />
          <Route path="masters-assessments/:assessmentName/mcq" element={<AssessmentMCQ />} />
          <Route path="masters-assessments/:assessmentName/mcq-attendees" exact element={<AssessmentMCQAttendees></AssessmentMCQAttendees>} />
          <Route path="masters-assessments/:assessmentName/practical-attendees" exact element={<AssessmentPracticalAttendees></AssessmentPracticalAttendees>} />
          <Route path="masters-assessments/:assessmentName/mcq-attendees/:name" exact element={<ViewAssessmentMCQExam></ViewAssessmentMCQExam>} />
          <Route path="masters-assessments/:assessmentName/practical-attendees/:name" exact element={<ViewPracticalExam></ViewPracticalExam>} />
          <Route path="masters-assessments/:assessmentName/mcq-sessions" exact element={<MCQSessions></MCQSessions>} />
          <Route path="masters-assessments/:assessmentName/practical-sessions" exact element={<PracticalSessions></PracticalSessions>} />
          <Route path="masters-assessments/:assessmentName/mcq/import" element={<UploadMCQ />} />
          <Route path="masters-assessments/:assessmentName/practical" element={<AssessmentPractical />} />
          <Route path="assessments" element={<Assessments />} />
          <Route path="assessments/:assessmentName" element={<UserAssessmentTypes />} />
          <Route path="assessments/:assessmentName/:type/confirm-start" element={<ConfirmAssessment />} />
          <Route path="assessments/:assessmentName/start-mcq" element={<MCQExam />} />
          <Route path="assessments/:assessmentName/start-practical" element={<PracticalExam />} />
          <Route path="assessments/:assessmentName/review-mcq" element={<ReviewMCQExam />} />
          <Route path="assessments/:assessmentName/review-practical" element={<ReviewPracticalExam />} />
          <Route path="quiz-dashboard" element={<QuizDashboard />} />
          <Route path="masters-quizzes" element={<MasterQuizzes />} />
          <Route path="masters-quizzes/add" element={<Quiz />} />
          <Route path="masters-quizzes/:quizName" element={<Quiz />} />
          <Route path="masters-quizzes/:quizName/:quiz-mapping" element={<QuizMapping />}/>
          <Route path="masters-quizzes/:quizName/mcq" element={<QuizMCQ />} />
          <Route path="masters-quizzes/:quizName/mcq/import" element={<UploadQuizMCQ />} />
          <Route path="masters-quizzes/:quizName/attendees" exact element={<MCQAttendees></MCQAttendees>} />
          <Route path="masters-quizzes/:quizName/sessions" exact element={<QuizMCQSessions></QuizMCQSessions>} />
          <Route path="masters-quizzes/:quizName/attendees/:name" exact element={<ViewQuizExam></ViewQuizExam>} />
          <Route path="quizzes" element={<Quizzes />} />
          <Route path="quizzes/:quizName/start" element={<QuizExam />} />
          <Route path="quizzes/:quizName/review" element={<ReviewQuizExam />} />
          <Route path="support" element={<Support />} />
          <Route path="support/add" element={<AddTicket />} />
          <Route path="agents" element={<Agents />} />
          <Route path="reports" element={<ReportDashboard />} />
          <Route path="reports/quiz-report" element={<QuizReport />} />
          <Route path="reports/assessment-report" element={<AssessmentReport />} />
          <Route path="reports/assessment-practical-report" element={<AssessmentPracticalReport />} />
          <Route path="reports/incident-report" element={<IncidentReport />} />
          <Route path="reports/incident-mis-report" element={<IncidentMisReport />} />
          <Route path="reports/bay-utilization-report" element={<VmLoginReport />} />
          <Route path="reports/bay-sessions-report" element={<BaySessionsReport/>} />
          <Route path="reports/login-history-report" element={<LoginHistoryReport />} />
          <Route path="reports/first-login-policy-acceptance-report" element={<FirstLoginHistoryReport />} />
          <Route path="reports/recent-login-history-report" element={<RecentLoginHistoryReport />} />
          <Route path="assigned-tickets" element={<TicketDashboard />} />
          <Route path="assigned-tickets/tickets" element={<Ticket />} />
          <Route path="masters-faq" element={<FaqList />} />
          <Route path="masters-faq/import" element={<UploadFAQ />} />
          <Route path="masters-faq/add" element={<FaqMaster />} />
          <Route path="masters-faq/edit/:type/:name" element={<FaqMaster />} />
          <Route path="audit-logs" element={<AuditLogsTable/>} />
          <Route path="expert-sessions/add" element={<CreateExpertSession key="create" />} />
          <Route path="expert-sessions" element={<ExpertSessions />} />
          <Route path="manage-metrics" element={<UpdateLabHoursCounts/>}/>
          <Route path="expert-sessions/edit/:sessionTitle" element={<CreateExpertSession key="edit" />} />
          <Route path="/expert-sessions/:sessionTitle" element={<SessionConfirmation />} />
          <Route path="faq" element={<Faq />} />
          <Route path="profile" element={<Profile />} />
          <Route path="profile/edit" element={<EditProfile />} />
          <Route path="profile/update-security" element={<UpdateSecurity />} />
          <Route path="/configureqr/:code" element={<MfaReconfigure />} />
          <Route path="profile/change-password" element={<ChangePassword />} />
          <Route path="profile/configure-mfa-otp" element={<VerifyOtp />} />
          <Route path="faq/:faqType" element={<FaqDetail />} />
          <Route path="bay" element={<CyberRange />} />
          <Route path="logout" element={<Logout />} />
        </Route>

        {/* Standalone MFA routes */}
        <Route path="/reset" element={<ProtectedRoute><Reset /></ProtectedRoute>} />
        <Route path="/qrcode" element={<ProtectedRoute><QrCode /></ProtectedRoute>} />
        <Route path="/questions" element={<ProtectedRoute><Question /></ProtectedRoute>} />
        <Route path="/mfa" element={<ProtectedRoute><MFA /></ProtectedRoute>} />
        <Route path="/mfaq" element={<ProtectedRoute><MFAQ /></ProtectedRoute>} />
        <Route path="/verifyotp" element={<ProtectedRoute><EmailVerifyOTP /></ProtectedRoute>} />

        {/* Error Screen*/}
        <Route path="/offline" element={<ErrorOffline />} />
        <Route path="/400" element={<Error400 />} />
        <Route path="/401" element={<Error401 />} />
        <Route path="/403" element={<Error403 />} />
        <Route path="/408" element={<Error408 />} />
        <Route path="/429" element={<Error429 />} />
        <Route path="/500" element={<Error500 />} />
        <Route path="/502" element={<Error502 />} />
        <Route path="/503" element={<Error503 />} />
        <Route path="/504" element={<Error504 />} />
        <Route path="*" element={<Error404 />} />
      </Routes>

    </>
  );
};

export default App;